export const NAME = 'interstitiel';

/**
 * Here goes the actionTypes
 */
export const REQUEST_RETAGGAGE = 'REQUEST_RETAGGAGE';
export const RECEIVE_RETAGGAGE = 'RECEIVE_RETAGGAGE';
export const FAILURE_RETAGGAGE = 'FAILURE_RETAGGAGE';



// WEBPACK FOOTER //
// ./src/services/interstitiel/constants.js